import { useEffect, useState } from 'react';
import './../styles/forgot-password.css';
import { ClipLoader } from 'react-spinners';
import ToastNotification, { showTopCenterToast } from '../components/toasts/ToastNotification';
import { forgotPassword } from '../api/auth.api';
import { useNavigate } from 'react-router-dom';

export const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const [isSent, setIsSent] = useState(false);

    const isValidEmail = (email) => emailRegex.test(email);

    useEffect(() => {
        document.title = "Quên mật khẩu";

        const storedTheme = localStorage.getItem("theme");
        if (storedTheme === "dark") {
            document.body.classList.add("dark-theme");
        } else {
            document.body.classList.remove("dark-theme");
        }
    }, []);

    const handleForgotPassword = async () => {
        if (!email) {
            showTopCenterToast("Vui lòng nhập email", "error");
            return;
        }

        if (!isValidEmail(email)) {
            showTopCenterToast("Sai định dạng email", "error");
            return;
        }

        try {
            setLoading(true);

            const res = await forgotPassword(email);

            if (res.success) {
                showTopCenterToast("Chúng tôi đã gửi đường link đặt lại mật khẩu tới mail của bạn", "success");
                setIsSent(true);
                setEmail("");
            }
        } catch (error) {
            showTopCenterToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <div className='forgot-password-container'>
            <ToastNotification/>
            <div className='forgot-password-wrapper'>
                <h3>Quên mật khẩu</h3>
                <p className='forgot-password-text'>Chúng tôi sẽ gửi cho bạn một email cho phép bạn đặt mật khẩu mới.</p>
                <div className='input-button-container'>
                    <input value={email} onChange={(e) => setEmail(e.target.value)} className='forgot-password-email-input' type='text' placeholder='Email'></input>
                    {isSent ? 
                        <button onClick={() => window.open('https://mail.google.com/', '_blank')} disabled={loading} className={`send-email-button ${loading && "disabled-button"}`}>Đi tới hộp thư</button>
                    : 
                        <button onClick={handleForgotPassword} disabled={loading} className={`send-email-button ${loading && "disabled-button"}`}>{loading ? <ClipLoader size={20} color='#fff'/> : "Tìm" }</button>
                    
                    }
                </div>
                <a href='/login' className='link-to-login'>Quay lại đăng nhập</a>
            </div>
        </div>
    );
}
